module.exports = __webpack_public_path__ + "static/team-background-e07d09b4d4c4aaadd454b2aecf234440.jpg";